import { z } from 'zod';
/**
 * Delete System Request Schema
 * DELETE /api/v2/systems/:id
 */ export const DeleteSystemRequestSchema = z.object({});
/**
 * Delete System Response Schema
 * DELETE /api/v2/systems/:id
 */ export const DeleteSystemResponseSchema = z.object({
    success: z.boolean()
});

//# sourceMappingURL=delete-system.schema.js.map